<template>
  <div>
    <div v-if="!isdetail">
      <!-- 默認訂單 -->
      <div>
        <div class="tablesheader">
          <div class="business_status">
            <div style="margin-right: 10px;">賣出進度:</div>
            <div>
              <el-select disabled="" v-model="saleStatus" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
        <div class="toolbox">
          <div class="mb15 toolleft" style="font-weight:800">默認賣出交易單</div>
          <div class="mb15 toolright">
            <template v-if="orderstatus<3">
              <el-link class="mr15" icon="el-icon-circle-plus">添加顯示交易單</el-link>
              <el-link class="mr15" icon="el-icon-circle-plus" @click="dialogSellTable=true">關聯交易</el-link>
              <el-link class="mr15" icon="el-icon-circle-plus" @click="dialogsellbusiness=true">添加交易單</el-link>
              <el-link icon="el-icon-circle-plus">上傳交易EXCEL</el-link>
            </template>
          </div>

          <el-dialog title="未關聯賣出記錄" :visible.sync="dialogSellTable" width="80%">
            <div v-if="dialogSellTable">
              <assoclate :order_id="order_id" :is_linker="0" :visible.sync="dialogSellTable" @reload="getdata"></assoclate>
            </div>
          </el-dialog>
          <el-dialog title="添加賣出交易" :visible.sync="dialogsellbusiness" width="80%" :close-on-click-modal="false">
            <div v-if="dialogsellbusiness">
              <sellbusinessadd :store_id="data.store_id" :is_linker="0" :order_id="order_id" :visible.sync="dialogsellbusiness" @submit="getdata"></sellbusinessadd>
            </div>
          </el-dialog>
        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="data.busienes" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="businessnum" label="交易編號" align="center">
              <template slot-scope="scope">
                <div class="phonecel">交易編號</div>
                <span :class="{'unlink':scope.row.status==5}">S{{scope.row.businessnum}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="addtime" label="時間" align="center">
              <template slot-scope="scope">
                <div class="phonecel">時間</div>
                <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="交易賬戶" align="center">
              <template slot-scope="scope">
                <div class="phonecel">交易賬戶</div>
                <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store_name}} {{scope.row.currency_short_name}}
                  {{scope.row.currency_name}} </div>
                <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
                  <div v-if="scope.row.bank_account.id">
                    <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
                    <div>{{scope.row.bank_account.bankname}} </div>
                    <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                  </div>
                  <div v-else>
                    未關聯賬戶
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="賣出貨幣" align="center">
              <template slot-scope="scope">
                <div class="phonecel">賣出貨幣</div>
                <span :class="{'unlink':scope.row.status==5}">{{scope.row.currency_short_name}} {{tomoney(scope.row.money)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hkd" label="折合港幣" align="center">
              <template slot-scope="scope">
                <div class="phonecel">折合港幣</div>
                <span :class="{'unlink':scope.row.status==5}">HKD {{tomoney(scope.row.hkd)}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="status" label="狀態" align="center">
              <template slot-scope="scope">
                <div class="phonecel">狀態</div>
                <statustext :status="scope.row.status"></statustext>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                <span style="color: #179A16;">
                  <el-link icon="el-icon-zoom-in" @click="detail(scope.row.id,0)" style="margin-right:10px;">詳情</el-link>
                  <el-link v-if="orderstatus!=3 && orderstatus!=5 && scope.row.status == 0" icon="el-icon-edit" @click="detail(scope.row.id,1)" style="margin-right:10px;">編輯</el-link>
                  <el-link v-if="orderstatus<3" icon="el-icon-error" @click="del(scope.row.id)">取消</el-link>
                </span>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div v-if="showpage" style="padding-top: 20px;">總數: {{data.order.busnum}} 筆訂單， 總折合港幣 {{tomoney(data.order.zhkd)}}
          HKD。
        </div>
      </div>
      <div>
        <div class="tablesheader">
        </div>
        <div class="toolbox">
          <div class="mb15 toolleft" style="font-weight:800;color:red">關聯賣出交易單</div>
          <div class="mb15 toolright">
            <el-link class="mr15" icon="el-icon-circle-plus">添加顯示交易單</el-link>
            <el-link class="mr15" icon="el-icon-circle-plus" @click="dialogSellTable2=true">關聯交易</el-link>
            <el-link class="mr15" icon="el-icon-circle-plus" @click="dialogsellbusiness2=true">添加交易單</el-link>
            <el-link icon="el-icon-circle-plus">上傳交易EXCEL</el-link>
          </div>

          <el-dialog title="未關聯賣出記錄" :visible.sync="dialogSellTable2" width="80%">
            <div v-if="dialogSellTable2">
              <assoclate :order_id="order_id" :is_linker="1" :visible.sync="dialogSellTable2" @reload="getdata"></assoclate>
            </div>
          </el-dialog>
          <el-dialog title="添加賣出交易" :visible.sync="dialogsellbusiness2" width="80%" :close-on-click-modal="false">
            <div v-if="dialogsellbusiness2">
              <sellbusinessadd :store_id="data.store_id" :is_linker="1" :order_id="order_id" :visible.sync="dialogsellbusiness2" @submit="getdata"></sellbusinessadd>
            </div>
          </el-dialog>
        </div>
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="data.busienes_linker" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="businessnum" label="交易編號" align="center">
              <template slot-scope="scope">
                <div class="phonecel">交易編號</div>
                <span :class="{'unlink':scope.row.status==5}">S{{scope.row.businessnum}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="addtime" label="時間" align="center">
              <template slot-scope="scope">
                <div class="phonecel">時間</div>
                <span :class="{'unlink':scope.row.status==5}">{{scope.row.addtime}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="" label="交易賬戶" align="center">
              <template slot-scope="scope">
                <div class="phonecel">交易賬戶</div>
                <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==0">{{scope.row.store_name}} {{scope.row.currency_short_name}}
                  {{scope.row.currency_name}} </div>
                <div :class="{'unlink':scope.row.status==5}" v-if="scope.row.mode==1">
                  <div v-if="scope.row.bank_account.id">
                    <div>{{scope.row.bank_account.account_name}} {{addSpace(scope.row.bank_account.account_num)}} </div>
                    <div>{{scope.row.bank_account.bankname}} </div>
                    <div>{{scope.row.currency_short_name}} {{scope.row.currency_name}} </div>
                  </div>
                  <div v-else>
                    未關聯賬戶
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="money" label="賣出貨幣" align="center">
              <template slot-scope="scope">
                <div class="phonecel">賣出貨幣</div>
                <span :class="{'unlink':scope.row.status==5}">{{scope.row.currency_short_name}} {{tomoney(scope.row.money)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="hkd" label="折合港幣" align="center">
              <template slot-scope="scope">
                <div class="phonecel">折合港幣</div>
                <span :class="{'unlink':scope.row.status==5}">HKD {{tomoney(scope.row.hkd)}}</span>
              </template>
            </el-table-column>

            <el-table-column prop="status" label="狀態" align="center">
              <template slot-scope="scope">
                <div class="phonecel">狀態</div>
                <statustext :status="scope.row.status"></statustext>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                <span style="color: #179A16;">
                  <el-link icon="el-icon-zoom-in" @click="detail(scope.row.id,0)" style="margin-right:10px;">詳情</el-link>
                  <el-link v-if="scope.row.status == 0" icon="el-icon-edit" @click="detail(scope.row.id,1)" style="margin-right:10px;">編輯</el-link>
                  <el-link icon="el-icon-error" @click="del(scope.row.id)">取消</el-link>
                </span>
              </template>
            </el-table-column>

          </el-table>
        </div>
        <div v-if="showpage" style="padding-top: 20px;">總數: {{data.order.busnum_linker}} 筆訂單， 總折合港幣 {{tomoney(data.order.zhkd_linker)}}
          HKD。
        </div>
      </div>
    </div>
    <div v-if="isdetail">
      <sellbuinessdetails :visible.sync="isdetail" :isedit="isedit" :isreadonly="true" @refresh="getdata" :id="business_id"></sellbuinessdetails>
    </div>
  </div>
</template>

<script>
import assoclate from "./SellBusienesAssoclate.vue";
import sellbusinessadd from "@/components/SellBusinessAdd.vue";
import sellbuinessdetails from "@/components/SellBusinessDetails.vue";
import statustext from "@/components/StatusText.vue";
export default {
  components: {
    assoclate,
    sellbusinessadd,
    sellbuinessdetails,
    statustext
  },
  props: ['order_id'],
  data () {
    return {
      saleStatus: 0,
      business_id: 0,
      isdetail: false,
      isedit: false,
      dialogSellTable: false, // 關聯買入訂單選擇列表
      dialogsellbusiness: false, // 添加賣出交易訂單
      dialogSellTable2: false, // 關聯買入訂單選擇列表
      dialogsellbusiness2: false, // 添加賣出交易訂單
      showpage: false,
      data: [],
      options: [{
        value: 0,
        label: 'Pending 準備中'
      }, {
        value: 1,
        label: 'Approved 已審核'
      }, {
        value: 2,
        label: 'Processing 處理中'
      }, {
        value: 3,
        label: 'Successful 已完成'
      }, {
        value: 4,
        label: 'Fail 失敗'
      },
      {
        value: 5,
        label: 'Deleted 已刪除'
      }],
      orderstatus: '',

    };
  },
  methods: {
    detail (id, type) {
      if (type == 1) {
        this.isedit = true;
      } else {
        this.isedit = false;
      }
      this.business_id = id;
      this.isdetail = true;
    },
    goByUrl (routerName) {
      this.$router.push({
        name: routerName
      })
    },
    del (id) {
      this.$confirm("確認取消關聯嗎", '詢問', {
        confirmButtonText: "確認",
        cancelButtonText: "取消",
        type: 'info'
      }).then(() => {
        let order_id = this.order_id;
        let staff_id = sessionStorage.getItem('staff_id');
        this.post('/api/order/unassociation', {
          id,
          order_id,
          staff_id
        })
          .then(res => {
            if (res == 'success') {
              this.$message({
                showClose: true,
                message: '取消成功',
                type: 'success',
              })
              this.getdata();
            }
          })
          .catch(error => { });
      }).catch((error) => {
        console.log(error);
      });;
    },
    getdata () {

      this.post('/api/order/busienes', {
        order_id: this.order_id,
        buytype: 1
      }).then((res) => {
        this.orderstatus = res.order.status;
        this.data = res;
        this.showpage = true;
        let business = res.busienes;
        if (business.length > 0) {
          this.saleStatus = 3;
          business.some(item => {
            if (item.status != 3) {
              this.saleStatus = item.status;
            }
          })

          if (this.saleStatus == 3) {
            this.$emit('update:checksell', true);
          }
        } else {
          this.saleStatus = 0;
          this.$emit('update:checksell', true);
        }
      }).catch((err) => {

        console.log(err)
      })
    }

  },
  created () {
    this.getdata();
  }
};
</script>

<style scoped>
.business_status {
  display: flex;
  align-items: center;
}

.tablesheader {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.toolbox {
  display: flex;
  justify-content: flex-end;
}

.toolright {
  width: 100%;
  text-align: right;
}

.toolleft {
  width: 150px;
}

.mb15 {
  margin-bottom: 15px;
}
</style>
